import { render, staticRenderFns } from "./search-bulk-messages.vue?vue&type=template&id=ec3bb634&scoped=true&"
import script from "./search-bulk-messages.vue?vue&type=script&lang=js&"
export * from "./search-bulk-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3bb634",
  null
  
)

export default component.exports